import { render } from "./WithIconAndDescription.vue?vue&type=template&id=4aa18e8c"
import script from "./WithIconAndDescription.vue?vue&type=script&lang=js"
export * from "./WithIconAndDescription.vue?vue&type=script&lang=js"
script.render = render

export default script